<app-table-generator
    [tableInput]="tableInputData"
    [widgetRef]="widgetRef"
    [tableData]="tablesData"
></app-table-generator>
